import React, { useState, useEffect } from 'react';

// Mounts its children the first time it becomes active, then keeps them mounted
// (hidden when inactive) so their state survives switching away and back.
const KeepMounted: React.FC<{ active: boolean; children: React.ReactNode }> = ({ active, children }) => {
  const [activated, setActivated] = useState(active);

  useEffect(() => {
    if (active) setActivated(true);
  }, [active]);

  if (!activated && !active) return null;
  return <div style={{ display: active ? undefined : 'none' }}>{children}</div>;
};

export default KeepMounted;
